<template>
  <div class="cinema-class-page">
    <van-nav-bar
      title="影院分类"
      left-text="返回"
      left-arrow
      fixed
      :placeholder="true"
      @click-left="goBack"
    />
    <div class="page-body">
      <div class="page-hero">
        <div class="hero-icon">
          <van-icon name="cluster-o" size="28" color="#5b9bd5" />
        </div>
        <h2 class="hero-title">我的分类</h2>
        <p class="hero-desc">自定义影院分组，用于自动报价、推送筛选等场景</p>
      </div>
      <div v-if="loading && classList.length === 0" class="loading-wrap">
        <van-loading size="24px" color="#1989fa">加载中...</van-loading>
      </div>
      <template v-else>
        <div v-if="classList.length > 0" class="class-list">
          <div
            v-for="item in classList"
            :key="item.id"
            class="class-card"
            :class="{ 'class-card-disabled': item.editable === false }"
            @click="item.editable !== false && goDetail(item.id)"
          >
            <div class="class-card-main">
              <div class="class-name">{{ item.name }}</div>
              <div class="class-count">
                <van-icon name="shop-o" size="12" color="#7eb8da" /> {{ item.cinema_count != null ? item.cinema_count : (item.cinema_list && item.cinema_list.length) || 0 }} 家影院
              </div>
            </div>
            <van-icon name="arrow" class="class-arrow" />
          </div>
          <div class="class-card class-card-new" @click="goNew">
            <div class="new-inner">
              <span class="new-icon-wrap"><van-icon name="plus" class="new-icon" /></span>
              <span class="new-text">新建分类</span>
            </div>
          </div>
        </div>
        <div v-else class="empty-wrap">
          <div class="empty-icon-wrap">
            <van-icon name="cluster-o" size="56" color="#c8c9cc" />
          </div>
          <p class="empty-text">还没有分类</p>
          <p class="empty-hint">创建分类后，可在报价方案中按分类筛选影院</p>
          <div class="class-card class-card-new empty-new-card" @click="goNew">
            <div class="new-inner">
              <span class="new-icon-wrap"><van-icon name="plus" class="new-icon" /></span>
              <span class="new-text">新建分类</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Api from '@/api-service'

export default {
  name: 'CinemaClass',
  data() {
    return {
      classList: [],
      loading: false
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    fetchList() {
      this.loading = true
      Api.getCinemaClassList({ page: 1, pageSize: 100 })
        .then(res => {
          const list = (res && res.list) || (res && res.data && res.data.list) || []
          this.classList = Array.isArray(list) ? list : []
        })
        .catch(() => {
          this.$toast.fail('加载失败')
          this.classList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    goDetail(id) {
      this.$router.push(`/cinema-class/${id}`)
    },
    goNew() {
      this.$router.push('/cinema-class/new')
    }
  }
}
</script>

<style lang="scss" scoped>
.cinema-class-page {
  min-height: 100vh;
  background: #f8f8f8;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Helvetica Neue', sans-serif;
}
.page-body {
  padding: 16px 16px 32px;
}
.page-hero {
  text-align: center;
  padding: 24px 16px 20px;
  margin-bottom: 12px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.hero-icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 12px;
  background: rgba(91, 155, 213, 0.12);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hero-icon .van-icon {
  color: #5b9bd5;
}
.hero-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 6px;
}
.hero-desc {
  font-size: 13px;
  color: #999;
  line-height: 1.5;
  margin: 0;
  max-width: 280px;
  margin-left: auto;
  margin-right: auto;
}
.class-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.class-card {
  width: calc(50% - 6px);
  background: #fff;
  border-radius: 12px;
  padding: 16px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  min-height: 72px;
  box-sizing: border-box;
  transition: box-shadow 0.2s ease;
}
.class-card:active {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.class-card::before {
  display: none;
}
.class-card-main {
  flex: 1;
  min-width: 0;
}
.class-name {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.class-count {
  font-size: 12px;
  color: #7eb8da;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 4px;
}
.class-count .van-icon {
  color: #7eb8da;
}
.class-arrow {
  color: #ccc;
  font-size: 14px;
  flex-shrink: 0;
  margin-left: 6px;
}
.class-card-disabled {
  opacity: 0.55;
  background: #f5f5f5;
  cursor: not-allowed;
  pointer-events: none;
}
.class-card-new {
  justify-content: center;
  border: none;
  background: #fff;
  min-height: 72px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.class-card-new:active {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.new-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.new-icon-wrap {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ee0a24;
  display: flex;
  align-items: center;
  justify-content: center;
}
.new-icon {
  color: #fff !important;
  font-size: 14px !important;
  font-weight: bold;
}
.new-text {
  color: #ee0a24;
  font-size: 14px;
  font-weight: 500;
}
.loading-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
}
.empty-wrap {
  text-align: center;
  padding: 40px 20px 32px;
}
.empty-icon-wrap {
  margin-bottom: 20px;
  opacity: 0.7;
}
.empty-icon-wrap .van-icon {
  color: #ccc;
}
.empty-text {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin: 0 0 8px;
}
.empty-hint {
  font-size: 13px;
  color: #999;
  line-height: 1.5;
  margin: 0 0 28px;
  padding: 0 10px;
}
.empty-new-card {
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
}

/* 与订单池一致的紧凑卡片布局 */
.cinema-class-page {
  background: var(--merchant-canvas);
}
.page-body {
  width: min(100%, 640px);
  margin: 0 auto;
  padding: 12px 12px 28px;
  box-sizing: border-box;
}
.page-hero {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  column-gap: 12px;
  padding: 14px;
  margin-bottom: 10px;
  text-align: left;
  border: 1px solid var(--merchant-line);
  border-radius: var(--merchant-radius);
  box-shadow: none;
}
.hero-icon {
  grid-row: 1 / span 2;
  width: 40px;
  height: 40px;
  margin: 0;
  border-radius: 10px;
  background: var(--merchant-brand-soft);
}
.hero-icon .van-icon {
  color: var(--merchant-brand) !important;
  font-size: 22px !important;
}
.hero-title {
  align-self: end;
  margin: 0 0 2px;
  color: var(--merchant-ink);
  font-size: 16px;
  font-weight: 650;
}
.hero-desc {
  max-width: none;
  margin: 0;
  color: var(--merchant-muted);
  font-size: 12px;
  line-height: 1.4;
}
.class-list {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
}
.class-card {
  width: 100%;
  min-height: 64px;
  padding: 13px 14px;
  border: 1px solid var(--merchant-line);
  border-radius: var(--merchant-radius);
  box-shadow: var(--merchant-shadow);
}
.class-card:active {
  transform: scale(0.99);
  border-color: #d9ddeb;
  box-shadow: none;
}
.class-name {
  margin-bottom: 5px;
  color: var(--merchant-ink);
  font-size: 14px;
  font-weight: 600;
}
.class-count {
  color: var(--merchant-muted);
}
.class-count .van-icon {
  color: var(--merchant-brand) !important;
}
.class-arrow {
  color: var(--merchant-muted);
}
.class-card-new {
  min-height: 58px;
  border: 1px dashed #cfd4e7;
  background: #fafaff;
  box-shadow: none;
}
.new-icon-wrap {
  background: var(--merchant-brand);
}
.new-text {
  color: var(--merchant-brand);
}
.empty-wrap {
  padding-top: 48px;
}
.empty-text {
  font-size: 15px;
}
.empty-new-card {
  max-width: 240px;
}
</style>
